let scopes = {
  application: {
    read: "module/application:read",
    edit: "module/application:edit",
  },
  project: {
    read: "module/project:read",
    create: "module/project:create",
    edit: "module/project:edit",
    delete: "module/project:delete",
  },
  setting: {
    read: "module/setting:read",
    write: "module/setting:write",
  },
  admin: {
    read: "module/admin:read",
    create: "module/admin:create",
    edit: "module/admin:edit",
    delete: "module/admin:delete",
  },
};

let role = {
  admin: "data360-admin",
  projectManager: "data360-project-manager",
  technician: "data360-technician",
  customer: "data360-customer",
  inspector: "data360-inspector",
};

let data360Roles = [
  role.admin,
  role.projectManager,
  role.technician,
  role.customer,
  role.inspector,
];

function customSort(a, b) {
  const order = [
    role.admin,
    role.projectManager,
    role.technician,
    role.customer,
    role.inspector,
  ];

  return order.indexOf(a) - order.indexOf(b);
}

let RBAC = [
  {
    name: role.admin,
    scopes: [
      scopes.application.read,
      scopes.application.edit,
      scopes.project.create,
      scopes.project.read,
      scopes.project.edit,
      scopes.project.delete,
      scopes.setting.read,
      scopes.setting.write,
      scopes.admin.create,
      scopes.admin.delete,
      scopes.admin.edit,
      scopes.admin.read,
    ],
  },
  {
    name: role.projectManager,
    scopes: [
      scopes.application.read,
      scopes.project.read,
      scopes.project.edit,
      scopes.admin.edit,
      scopes.admin.read,
    ],
  },
  {
    name: role.technician,
    scopes: [scopes.application.read, scopes.project.read, scopes.admin.read],
  },
  {
    name: role.customer,
    scopes: [scopes.application.read, scopes.project.read, scopes.admin.read],
  },
  {
    name: role.inspector,
    scopes: [scopes.application.read, scopes.project.read, scopes.admin.read],
  },
];

export { RBAC, scopes, role, data360Roles, customSort };
